// src/pages/Privacy.jsx
import React from 'react';
import { Box, Typography, useTheme, Link } from '@mui/material';
import Footer from '../components/Footer';

////////////////////////////////////////////////////////////////////////////////////////
// 자동 목차 (예시: 실제 회사 방침에 맞게 수정해서 사용)
////////////////////////////////////////////////////////////////////////////////////////
const privacyHeadings = [
  { id: '1.-개인정보의-처리-목적', label: '1. 개인정보의 처리 목적' },
  { id: '2.-개인정보의-처리-및-보유-기간', label: '2. 개인정보의 처리 및 보유 기간' },
  { id: '3.-정보주체와-법정대리인의-권리·의무-및-그-행사방법', label: '3. 정보주체와 법정대리인의 권리·의무' },
  { id: '4.-처리하는-개인정보의-항목-작성', label: '4. 처리하는 개인정보 항목' },
  { id: '5.-개인정보의-파기', label: '5. 개인정보의 파기' },
  { id: '6.-개인정보-자동-수집-장치의-설치•운영-및-거부에-관한-사항', label: '6. 개인정보 자동 수집 장치' },
  { id: '7.-개인정보-보호책임자', label: '7. 개인정보 보호책임자' },
  { id: '8.-개인정보-처리방침-변경', label: '8. 개인정보 처리방침 변경' },
  { id: '9.-개인정보의-안전성-확보-조치', label: '9. 개인정보의 안전성 확보 조치' },
  { id: '10.-개인정보의-제3자-제공-및-위탁', label: '10. 개인정보의 제3자 제공 및 위탁' },
];

const privacyContent = `

## 1. 개인정보의 처리 목적
① 전적이는 다음의 목적을 위하여 개인정보를 처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다.
고객에 대한 서비스 제공에 따른 본인 식별·인증, 회원 자격 유지·관리 등

## 2. 개인정보의 처리 및 보유 기간
① 전적이는 정보주체로부터 개인정보를 수집할 때 동의 받은 개인정보 보유·이용기간 또는 법령에 따른 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
② 구체적인 개인정보 처리 및 보유 기간은 다음과 같습니다.
챗봇의 원활한 운영 및 사용자 식별
  디스코드 고유 ID, 닉네임
수집기간
  서비스 종료 시까지 보관을 원칙으로 함

## 3. 정보주체와 법정대리인의 권리·의무 및 그 행사방법
① 정보주체는 전적이에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
개인정보 열람 요구
정보의 영구 삭제 요구

## 4. 처리하는 개인정보의 항목 작성
① 전적이는 다음의 개인정보 항목을 처리하고 있습니다.
필수항목: 봇 이용 로그 - 봇 이용자, 봇 이용 메세지, 봇 이용 시간
선택항목: 봇의 급식정보기능 사용 - 이용자의 학교정보(학교고유코드)

## 5. 개인정보의 파기
① 전적이는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체 없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.
파기절차
  이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
파기기한
  이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유 기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.

## 6. 개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항
① 전적이는 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 챗봇을 사용합니다. 이용정보의 저장을 거부할 경우 전체 서비스 이용에 어려움이 생길 수 있습니다.
② 챗봇의 이용 정보는 이용 플랫폼과 환경에 따라 다른 사용자에게 공개될 수 있습니다.

## 7. 개인정보 보호책임자
① 전적이는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
 개인정보 보호책임자
  성명 : 박근우
  직책 : 대표
  메일 : admin@jeonjeok.xyz
② 정보주체께서는 전적이의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 전적이는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.

## 8. 개인정보 처리방침 변경
① 이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.

## 9. 개인정보의 안전성 확보 조치
① 전적이는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.
내부관리계획의 수립 및 시행
개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.
개인정보에 대한 접근 제한
개인정보를 처리하는 데이터베이스 시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.

## 10. 개인정보의 제3자 제공 및 위탁
① 제 3자 제공
당사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.  
  1. 정보주체에게 별도 동의를 받은 경우
  2. 법령에 특별한 규정이 있는 경우
② 업무 위탁
당사는 서비스 안정적 운영을 위해 아래와 같이 개인정보 처리 업무를 위탁하고 있습니다.
  1. 위탁업체: 오라클 코퍼레이션(Oracle Cloud Infrastructure)
   위탁업무: 디스코드 봇 서버 호스팅, DB·로그 저장 및 백업
`;

function parseIndentedText(text) {
  // 줄 단위로 나눈다
  const lines = text.split('\n');

  return lines.map((rawLine, idx) => {
    const line = rawLine.trim();
    if (!line) {
      return null;
    }


    let styleProps = {
      ml: 0,
      mb: 1,
    };

    if (/^[①-⑳]/.test(line)) {
      styleProps = {
        ...styleProps,
        ml: 2,
        textIndent: '-1.4em',
      };
    }

    else if (/^\d+\./.test(line)) {
      styleProps = {
        ...styleProps,
        ml: 4,
        textIndent: '-1em',
      };
    }

    return (
      <Typography key={idx} variant="body2" sx={{ lineHeight: 1.8, ...styleProps }}>
        {line}
      </Typography>
    );
  });
}

function Privacy() {
  const theme = useTheme();
  const renderContent = () => {
    const sections = privacyContent
      .split(/(?=(?:## .+|### .+))/g)
      .filter(Boolean);

    return sections.map((section, idx) => {
      const trimmedSection = section.trim();

      if (trimmedSection.startsWith('## ')) {
        const match = trimmedSection.match(/## (.*?)\n([\s\S]*)/);
        if (match) {
          const heading = match[1].trim();    // ex) "1. 개인정보의 처리 목적"
          const content = match[2] || '';     // 해당 본문
          const headingId = heading.replace(/\s/g, '-');

          return (
            <Box key={idx} id={headingId} sx={{ mb: 4, scrollMarginTop: '80px' }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
                {heading}
              </Typography>
              {parseIndentedText(content)}
            </Box>
          );
        }
      }
      else if (trimmedSection.startsWith('### ')) {
        const match = trimmedSection.match(/### (.*?)\n([\s\S]*)/);
        if (match) {
          const subHeading = match[1].trim();
          const content = match[2] || '';
          const subHeadingId = subHeading.replace(/\s/g, '-');

          return (
            <Box key={idx} id={subHeadingId} sx={{ mb: 4, scrollMarginTop: '80px' }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                {subHeading}
              </Typography>
              {/* 들여쓰기 적용 */}
              {parseIndentedText(content)}
            </Box>
          );
        }
      }

      return null;
    });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        bgcolor: theme.palette.background.default,
        color: theme.palette.text.primary,
        minHeight: '100vh',
      }}
    >
      {/* 왼쪽 사이드바 (목차) */}
      <Box
        component="aside"
        sx={{
          width: { md: '250px' },
          flexShrink: 0,
          position: { md: 'sticky' },
          top: { md: 80 },
          height: { md: 'calc(100vh - 80px)' },
          overflowY: 'auto',
          p: 3,
          borderRight: { md: `1px solid ${theme.palette.divider}` },
          display: { xs: 'none', md: 'block' },
        }}
      >
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
          📚 목차
        </Typography>
        {privacyHeadings.map((item) => (
          <Link
            key={item.id}
            href={`#${item.id}`}
            underline="hover"
            color="inherit"
            sx={{ display: 'block', mb: 1, cursor: 'pointer' }}
            onClick={(e) => {
              e.preventDefault();
              const target = document.getElementById(item.id);
              if (target) {
                target.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            {item.label}
          </Link>
        ))}
      </Box>

      {/* 오른쪽 본문 */}
      <Box
        component="main"
        sx={{
          flex: 1,
          px: { xs: 3, sm: 6 },
          py: 6,
          pt: '80px',
        }}
      >
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontWeight: 'bold', mb: 6 }}
        >
          개인정보처리방침
        </Typography>

        {renderContent()}

        <Footer />
      </Box>
    </Box>
  );
}

export default Privacy;
